<template>
     <div>
         <div class="panel panel-default" style="overflow: visible !important">
           <div class="panel-heading">
               <div style="display: flex; justify-content: space-between; align-items: center;">
                   <span>
                       Campaigns
                   </span>
               </div>
           </div>
           <div class="panel-body">
               <div id="campaign-actions" class="level jc-sb fd-res ai-s">
                   <div class="level ai-c">
                       <div class="mr-1">Filter:</div>
                       <ul class="nav nav-pills" id="campaign-options">
                           <li role="presentation" :class="filter == 'active' ? 'active' : ''"><a @click="refreshList('active')">ACTIVE</a></li>
                           <li role="presentation" :class="filter == 'inactive' ? 'active' : ''"><a @click="refreshList('inactive')">INACTIVE</a></li>
                           <li role="presentation" :class="filter == 'all' ? 'active' : ''"><a @click="refreshList('all')">ALL</a></li>
                       </ul>
                   </div>
                   <div id="bulk-edits" class="level fd-c">
                       <div class="level ai-c">
                           <div class="mr-1">Bulk Edit:</div>
                           <ul class="nav nav-pills" id="campaign-options">
                               <li role="presentation" :class="editing ? 'active' : ''"><a @click="toggleBulkEdit">BUDGET GROUPS</a></li>
                           </ul>
                       </div>
                       <div class="level mt-1 ai-e" v-if="editing">
                           <v-select v-model="selectedGroups" :options="selectOptions" options-value="val" multiple placeholder="Select Groups" ></v-select>
                           <button type="button" class="btn btn-default ml-1" @click="bulkSave">
                               <i class="fa fa-save"></i>
                           </button>
                       </div>
                   </div>
               </div>
                <div class="campaign-table-container">
                    <table class="table campaigns">
                       <thead>
                           <tr>
                               <th v-if="editing" class="tac">
                                   <input type="checkbox" @input="toggleSelectAll">
                               </th>
                               <th class="campaign-name-cell">Name</th>
                               <th class="budget-group-cell">Budget Groups</th>
                               <th v-if="!editing" class="tac">Exclude</th>
                               <th v-else></th>
                           </tr>
                       </thead>
                       <tbody v-if="loadingCampaigns">
                           <tr>
                               <td></td>
                               <td class="loading">
                                    <i class="fa fa-refresh fa-spin fa-fw"></i>
                                    <span class="sr-only">Loading...</span>
                               </td>
                               <td></td>
                           </tr>
                       </tbody>
                       <tbody v-if="!loadingCampaigns">
                           <tr v-for="(campaign, idx) in account.campaigns">
                               <td v-if="editing" class="tac">
                                   <input type="checkbox" :value="campaign" v-model="pendingBulk" :disabled="campaign.exclude === 1" :title="campaign.exclude === 1 ? 'Excluded' : ''">
                               </td>
                               <td class="campaign-name-cell">
                                   {{ campaign.name }}
                               </td>
                               <td v-if="!editing" class="budget-group-cell">
                                   <template v-if="!campaign.exclude">
                                        <v-select v-model="campaign.budgets" :options="selectOptions" options-value="val" multiple placeholder="Select Groups"></v-select>
                                        <button type="button" :class="['btn', savedState(idx) ? 'btn-success' : 'btn-default']" @click="updateBudgetGroups(campaign, idx)">
                                            <i class="fa fa-check" v-if="savedState(idx)"></i>
                                            <i class="fa fa-save" v-else></i>
                                        </button>
                                   </template>
                                   <span v-else>Excluded</span>
                               </td>
                               <td v-else class="budget-group-cell">
                                   {{ campaignBudgetGroupsString(campaign) }}
                               </td>
                               <td v-if="!editing" class="tac">
                                   <input type="checkbox" v-model="campaign.exclude" @change="updateCampaign(campaign)">
                               </td>
                               <td v-else></td>
                           </tr>
                       </tbody>
                    </table>
                </div>
               </div>
           </div>
         </div>
     </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { select } from 'vue-strap';

export default {
    components: { vSelect: select },

    data() {
        return {
            filter: 'active',
            campaigns: {

            },
            loadingCampaigns: true,
            saved: [],
            editing: false,
            pendingBulk: [],
            selectedGroups: [],
        }
    },

    computed: {
        ...mapGetters('client',{
            'account': 'activeAdAccount',
            'isAdmin': 'isAdmin',
            'client': 'activeClient',
        }),

        selectOptions() {
            return this.client.budget_groups.filter(g => g.name !== 'Monthly')
                .map((g) => {
                    return {val: g.id, label: g.name }
                });
        }
    },

    created() {
        Bus.$on('load-campaign-list', this.prepareComponent);
        Bus.$on('reload-campaign-list', () => {
            this.filter = 'all'
            this.getCampaignListForAccount()
        });
    },

    methods: {
        prepareComponent() {
            this.editing = false;
            this.getCampaignListForAccount();
        },

        getCampaignListForAccount() {
            this.loadingCampaigns = true;
            this.$store.dispatch('client/getCampaignList',{
                filter: this.filter
            }).then((campaigns) => {
                this.campaigns = campaigns;
                this.loadingCampaigns = false;
            })
            .catch((response) => {
                Bus.$emit('show-error-alert', response.data.message);
            })
        },

        updateCampaign(campaign) {
            campaign.exclude = campaign.exclude ? 1 : 0;
            this.$store.dispatch('client/updateCampaign',{
                campaign: campaign
            }).then((response) => {
                // Bus.$emit('show-success-alert', response.message);
            })
            .catch((response) => {
                Bus.$emit('show-error-alert', response.data.message);
            })
        },

        updateBudgetGroups(campaign, idx) {
            axios.patch(`/api/campaigns/budget-groups`, {
                budget_group_ids: campaign.budgets,
                campaigns: [campaign],
                bulk: false
            })
            .then(({data}) => {
                this.saved.push(idx);
                setTimeout(() => this.saved = [], 1000);
            })
            .catch(({response}) => {
                Bus.$emit('show-error-alert', response.data.message);
            });
        },

        savedState(idx) {
            return this.saved.indexOf(idx) != -1;
        },

        refreshList(status) {
            this.filter = status;
            this.getCampaignListForAccount();
        },

        campaignBudgetGroupsString(campaign) {
            return campaign.budget_groups.map((g) => {
                return this.selectOptions.find((option) => option.val == g.id).label;
            }).join(', ');
        },

        toggleBulkEdit() {
            this.editing = ! this.editing;
            this.pendingBulk = [];
            this.selectedGroups = [];
        },

        toggleSelectAll() {
            if (this.pendingBulk.length < this.account.campaigns.length) {
                this.pendingBulk = []
                this.account.campaigns.forEach(c => this.pendingBulk.push(c))
                return
            }
            this.pendingBulk = []
        },

        bulkSave() {
            axios.patch(`/api/campaigns/budget-groups`, {
                budget_group_ids: this.selectedGroups,
                campaigns: this.pendingBulk,
                bulk: true
            })
            .then(({data}) => {
                this.toggleBulkEdit();
                this.getCampaignListForAccount();
                Bus.$emit('show-success-alert', data.message);
            });
        }
    }
}
</script>

<style scoped>
    div.campaign-table-container {
        overflow: visible;
    }

    @media (max-width: 767px) {
        div.campaign-table-container {
            overflow-x: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/AdAccountCampaignList.vue